import PayDictionary from './dictionary'
import PayAgreement from './agreement'
import axios from 'axios'

export default class Pay {
  constructor(props) {
    this._form = {
      id: props.action === 'edit' ? props.id : 0,
      direction: 0,
      operation: 0,
      rateArticle: 0,
      category: 0,
      type: 0,
      cash: 0,
      account: 0,
      accountNumber: '',
      contragentType: 1,
      contragent: '',
      contragentName: '',
      legal: '',
      legalName: '',
      sum: 0,
      currency: 1,
      reason: '',
      comment: '',
    };
    this.isReservationCenter = false;
    this.isSubAgent = false;

    this._loading = false;
    this.$dictionary = new PayDictionary();
    this.$agreement = new PayAgreement();
    this.timer = null;
    this.catalogData = null;
    this.$store = props.context;
    this.$props = {
      edit: props.action === 'edit',
      action: props.action,
      id: props.id,
      date: props.date ? props.date : '',
    }
  }

  get loading() {
    return this._loading;
  }

  set loading(value) {
    this._loading = value;
  }

  get id() {
    return this._form.id;
  }

  set id(value) {
    this._form.id = value;
  }

  get direction() {
    return this._form.direction;
  }

  set direction(value) {
    const old = this._form.direction;
    this._form.direction = value;
    const operation = this.dictionary.operations.sort((a, b) => a.id - b.id).find(operation => {
      if (operation.direction !== value) return false;
      switch (this.contragentType) {
        case 1:
        case 2:
          if (
            operation.id === 5 ||
            operation.id === 6 ||
            operation.id === 9 ||
            operation.id === 10
          ) return false;
          return operation.agreement;
        case 3:
          if (
            operation.id === 1 ||
            operation.id === 2 ||
            operation.id === 3 ||
            operation.id === 4 ||
            operation.id === 7 ||
            operation.id === 8
          ) return false;
          return operation.agreement;
        case 5:
        case 6:
          return !operation.agreement;
        case 7:
          return operation.agreement;
      }
    });
    if (!operation) {
      this._form.direction = old;
      return;
    }
    this.operation = operation.value;
    this.setFilters();
  }

  get operation() {
    return this._form.operation;
  }

  set operation(value) {
    const old = this._form.operation;
    this._form.operation = value;
    const operation = this.dictionary.operations.find(i => i.id === value);
    if (this.agreements.length && !operation.agreement) {
      window.app.$confirm('Выбранная платёжная операция не относится к операциям, совершаемым по путёвкам. Прикреплённые путёвки будут удалены из платежа. Изменить платёжную операцию?', 'Внимание!', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
        center: true
      }).then(() => {
        window.app.$message({
          type: 'success',
          message: 'Платёжная операция изменена!'
        });
        this.setOperation(operation);
        this.setFilters();
      }).catch(() => {
        this._form.operation = old;
        window.app.$message({
          type: 'info',
          message: 'Платёжная операция не изменилась!'
        });
      });
    } else {
      this.setOperation(operation);
      this.setFilters();
    }
  }

  get rateArticle() {
    return this._form.rateArticle;
  }

  set rateArticle(value) {
    this._form.rateArticle = value;
  }

  get category() {
    return this._form.category;
  }

  set category(value) {
    this._form.category = value;
    const type = this.dictionary.types.find(i => i.category === value && i.id !== 0);
    this.type = type ? type.id : 0;
    if (!type) {
      window.app.$message({
        type: 'info',
        message: 'Отсутствует тип платежа!'
      });
    }
    switch (value) {
      case 0:
        const cash = this.dictionary.cashes[0];
        if (cash) {
          this.cash = cash.value;
        } else {
          this.cash = '';
          window.app.$message({
            type: 'info',
            message: 'Заведите кассу!'
          });
        }
        break;
      case 1:
        const account = this.dictionary.accounts[0];
        if (account) {
          this.account = account.value;
        } else {
          this.account = '';
          window.app.$message({
            type: 'info',
            message: 'Заведите счет!'
          });
        }
        break;
    }
    this.setFilters();
  }

  get type() {
    return this._form.type;
  }

  set type(value) {
    this._form.type = value;
  }

  get cash() {
    return this._form.cash;
  }

  set cash(value) {
    this._form.cash = value;
  }

  get account() {
    return this._form.account;
  }

  set account(value) {
    this._form.account = value;
  }

  get accountNumber() {
    return this._form.accountNumber;
  }

  set accountNumber(value) {
    this._form.accountNumber = value;
  }

  get contragentType() {
    return this._form.contragentType;
  }

  set contragentType(value) {
    const old = this._form.contragentType;
    this._form.contragentType = value;
    this.setFilters();
    if (this.$agreement.main) {
      const contragent = this.$agreement.contragents[0];
      if (contragent) {
        this.contragent = contragent.value;
      }
    }else{
      if (old === 7 && value !== 7) {
        this.legal = '';
      }
    }
    this.setFilters();
  }

  get contragent() {
    return this._form.contragent;
  }

  set contragent(value) {
    this._form.contragent = value;
    this.setFilters();
    if (this.$agreement.main) {
      const contragent = this.$agreement.contragents.find(i => i.value === value);
      this.contragentName = contragent ? contragent.label : '';
      const legal = this.$agreement.legals[0];
      this.legal = legal ? legal.value : '';
    }
  }

  get contragentName() {
    return this._form.contragentName;
  }

  set contragentName(value) {
    this._form.contragentName = value;
  }

  get contragents() {
    const data = [];
    data.concat(this.agreement.contragents);
    if (!data.find(i => i.value === this.contragent)) {
      if (this.contragent) {
        data.push({
          Id: this.contragent,
          Name: this.contragentName,
          id: this.contragent,
          name: this.contragentName,
          value: this.contragent,
          label: this.contragentName,
          type: this.contragentType,
          legal: 0,
          legals: [],
          allow: false,
          client: false,
          operator: false,
        })
      }
    }
    return data;
  }

  get legal() {
    return this._form.legal;
  }

  set legal(value) {
    this._form.legal = value;
    this.setFilters();
  }

  get legalName() {
    return this._form.legalName;
  }

  set legalName(value) {
    this._form.legalName = value;
  }

  get sum() {
    return this._form.sum;
  }

  set sum(value) {
    this._form.sum = value;
    this.agreement.value = value;
  }

  get currency() {
    return this._form.currency;
  }

  set currency(value) {
    this._form.currency = value;
    this.setFilters();
  }

  get reason() {
    return this._form.reason;
  }

  set reason(value) {
    this._form.reason = value;
  }

  get comment() {
    return this._form.comment;
  }

  set comment(value) {
    this._form.comment = value;
  }

  get dictionary() {
    return this.$dictionary;
  }

  get agreement() {
    return this.$agreement;
  }

  get agreements() {
    return this.$agreement.items;
  }


  get action() {
    return this.$props.action;
  }

  get operationAgreement() {
    const operation = this.dictionary.operations.find(i => i.id === this.operation);
    return operation ? operation.agreement : false;
  }

  get operationBonus() {
    const operation = this.dictionary.operations.find(i => i.id === this.operation);
    return operation ? operation.bonuses : false;
  }

  get iso() {
    return this.getIso(this.currency);
  }
  get currencyMain() {
    const currency = this.$dictionary.currencies.find(i => i.national);
    return currency ? currency.value : 0;
  }

  init() {
    const self = this;
    return new Promise((resolve, reject) => {
      Promise
        .all([
          self.getCatalogData()
        ])
        .then(resolve, reject);
    });
  }

  getCatalogData() {
    const self = this;
    return new Promise((resolve, reject) => {
      axios
        .get(`/tourclient/payment/paymentCatalogsData?_=${new Date().getTime()}`)
        .then(({data}) => {
          self.setCatalogData(data);
          resolve(self);
        })
        .catch(err => {
          reject();
        })
    });
  }

  setCatalogData(data) {
    this.dictionary.set(data);
    this.agreement.set(data);
    this.catalogData = data;
    this.isReservationCenter = data.IsReservationCenter;
    this.isSubAgent = data.IsSubAgent;
  }

  setOperation(operation) {
    if (!operation) return;
    const id = operation.id;
    this.category = operation.category;
    this._form.type = operation.type;
    const contragentTypes = [];
    if (operation.agreement) {
      if (!(id === 1 || id === 2 || id === 3 || id === 4 || id === 7 || id === 8)) {
        contragentTypes.push(3);
      }
      if (!(id === 5 || id === 6 || id === 9 || id === 10)) {
        contragentTypes.push(1);
        contragentTypes.push(2);
      }
      contragentTypes.push(7);
    } else {
      contragentTypes.push(5);
      contragentTypes.push(6);
    }
    if (contragentTypes.indexOf(this.contragentType) < 0) {
      this.contragentType = contragentTypes[0];
    }
    this.agreement.mask = operation.reason;
  }

  setFilters() {
    this.$agreement.set(this._form);
  }

  agreementAdd(code) {
    const self = this;
    return new Promise((resolve, reject) => {
      self._loading = true;
      self.$agreement
        .add(code)
        .then(data => {
          if (self.$agreement.items.length === 1) {
            const contragent = self.$agreement.main.contragents[0];
            if (contragent) {
              this.contragent = contragent.value;
              if (contragent.legals.length) {
                this.legal = contragent.legals[0].value;
              } else {
                this.legal = '';
              }
            }
          }
          data.getCourses(self.usePartnerCourse).then().finally(()=>{
            data.setSum();
            setTimeout(()=>{
              if (self.agreement.value > self.sum) {
                self.sum = self.agreement.value;
              }
              resolve();
            },1)
          })
        }, reject)
        .finally(() => {
          self._loading = false;
        })
    });
  }

  agreementRemove(code) {
    const self = this;
    self.$agreement.remove(code);
  }

  getIso(value) {
    const currency = this.$dictionary.currencies.find(i => i.value === value);
    return currency ? currency.label : '';
  }


}
